module.exports = __webpack_public_path__ + "static/media/head.53ccd981.png";